module.exports = __webpack_public_path__ + "img/exp2.431b83f4.png";